<template>
  <div class="row align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-6 col-xl-4 px-lg-6 my-5">
      <template v-if="sent">
        <h1>Password Reset Email Sent</h1>

        <p>Graduates will receive the email to their current NSW Government email address as well as their personal email address.</p>

        <p>If you require assistance, please email <a href="mailto:nswgraduateprogram@premiersdepartment.nsw.gov.au" target="_blank">nswgraduateprogram@premiersdepartment.nsw.gov.au</a></p>

        <p class="mt-4 text-muted">
          <router-link :to="{ name: 'login' }">Return to sign in page.</router-link>
        </p>
      </template>
      <template v-else>
        <h1>Forgot Your Password?</h1>

        <p class="strong">Please enter your username or email address to reset your password. </p>

        <form @submit.prevent>
          <div class="form-group">
            <label>Email Address / Username</label>
            <input
              type="text"
              class="form-control"
              v-model="identifier"
              name="identifier"
              data-vv-as="email or username"
              v-validate.disable="'required'"
            >
          </div>
          <!-- /.form-group -->

          <div
            class="alert alert-danger"
            v-if="errors.has('identifier')"
            v-html="errors.first('identifier')"
          />

          <ladda-button
            type="submit"
            class="btn btn-block btn-primary mb-3"
            :validate="true"
            :click="forgotPassword"
            :arguments="[identifier]"
            :done="() => sent = true"
            :failed="failed"
          >Reset Password</ladda-button>
        </form>

        <p>Please note, access is not synced with your agency network sign in.</p>

        <p>If you require assistance, please email <a href="mailto:nswgraduateprogram@premiersdepartment.nsw.gov.au" target="_blank">nswgraduateprogram@premiersdepartment.nsw.gov.au</a></p>

        <p class="mt-4 text-muted">
          Remember your password?
          <router-link :to="{ name: 'login' }">Sign In</router-link>.
        </p>
      </template>
    </div>
  </div>
  <!-- /.row -->
</template>

<script>
import { authMethods } from 'vx/helpers'

export default {
  data () {
    return {
      identifier: null,
      error: null,
      sent: false
    }
  },

  methods: {
    ...authMethods,

    failed (error) {
      let field = this.$validator.fields.find({ name: 'identifier' })

      field.setFlags({ invalid: true, valid: false, validated: true })

      let msg = null

      if (error.response) {
        if (error.response.status === 422) {
          msg = error.response.data.errors.identifier.pop()
        } else {
          msg = error.response.data.message
        }
      } else {
        msg = 'Something went wrong when sending the password reset email. Please try again.'
      }

      this.errors.add({ field: field.name, msg, id: field.id })
    }
  }
}
</script>
